import { gql } from '@apollo/client';

export const PREPARE_FILE_FOR_ZIP = gql`
  mutation prepareFileForZip($batchId: String!, $url: String!, $filename: String!) {
    prepareFileForZip(batchId: $batchId, url: $url, filename: $filename)
  }
`;
